/**
 * NOLAS 2026, (c) Mikaël FOURNY.
 * src/i18n/fr.cvPhoto.ts
 *
 * Messages du CV déposé en photo : formats conseillés et acceptés, bouton
 * « prendre en photo », état de la lecture du texte, refus du serveur
 * traduits à partir de leur code. Fusionné dans fr.ts.
 *
 * Règle de Mika (2026-10-04) : la photo n'est jamais interdite, elle est
 * seulement déconseillée quand on a le fichier ; et si l'IA ne peut pas la
 * lire, la personne lit un conseil neutre, jamais une erreur technique.
 *
 * Mikael - chef de projet - 2026-10-04
 */
export const messagesCvPhotoFr: Record<string, string> = {
  'cvPhoto.conseil.recommande':
    'Recommandé : PDF ou Word, lisibles par les recruteurs et par la recherche.',
  'cvPhoto.conseil.photo':
    'Une photo est acceptée, mais elle est moins lisible : à éviter si vous avez le fichier.',
  'cvPhoto.conseil.limite': 'Formats acceptés : {ext}. {mo} Mo au maximum.',
  'cvPhoto.conseil.limiteAvecPhoto':
    'Formats acceptés : {ext}. {mo} Mo au maximum, une photo est allégée automatiquement avant l’envoi.',
  'cvPhoto.bouton.photo': 'Prendre mon CV en photo',
  'cvPhoto.bouton.photo.aria': 'Prendre une photo de votre CV papier avec l’appareil photo',
  'cvPhoto.preparation': 'Préparation de la photo…',
  'cvPhoto.etat.enCours':
    'Votre CV est une photo : nous en lisons le texte pour qu’il soit aussi trouvé par la recherche. Vous pouvez quitter cette page.',
  'cvPhoto.etat.lue':
    'Votre CV est une photo : son texte a été lu, il est aussi trouvé par la recherche. Un PDF ou un Word reste plus net pour les recruteurs.',
  'cvPhoto.etat.neutre':
    'Votre CV est une photo : il reste consultable par les recruteurs. Pour qu’il soit aussi trouvé par la recherche, déposez si possible un PDF ou un Word.',
  'cvPhoto.erreur.tropLourd':
    'Ce fichier pèse {taille}, la limite est de {mo} Mo. Enregistrez votre CV en PDF, ou, pour une photo, reprenez-la depuis cette page : elle sera allégée automatiquement.',
  'cvPhoto.erreur.tropLourdSansTaille':
    'Ce fichier dépasse la limite de {mo} Mo. Enregistrez votre CV en PDF, ou, pour une photo, reprenez-la depuis cette page : elle sera allégée automatiquement.',
  'cvPhoto.erreur.imageIllisible':
    'Cette image n’a pas pu être lue. Reprenez la photo, ou déposez un PDF ou un Word.',
  'cvPhoto.erreur.imageTropGrande':
    'Cette photo est trop grande pour être traitée. Reprenez-la en qualité standard, ou déposez un PDF ou un Word.',
  'cvPhoto.erreur.contenu':
    'Ce fichier n’est pas ce que son nom annonce. Déposez un vrai document (PDF, Word, ODT) ou une photo (JPEG, PNG, HEIC).',
  'cvPhoto.erreur.format':
    'Format non accepté. Recommandé : PDF ou Word. Une photo (JPEG, PNG, HEIC) est aussi acceptée.',
};
